$(window).on('load', () => {

    $('.service-price').on('input', updateServiceBudgetFromEvent);

    $('.service-goal').on('input', updateServiceBudgetFromEvent);

    for (let budgetInput of document.querySelectorAll('.service-budget')) {
        updateServiceBudget(budgetInput)
    }

});

function updateServiceBudgetFromEvent(event) {
    updateServiceBudget(event.currentTarget)
}

function updateServiceBudget(el) {
    const parent = el.parentNode.parentNode;
    const budget = parent.querySelector('.service-budget');
    const price = parent.querySelector('.service-price');
    const goal = parent.querySelector('.service-goal');

    if (price && goal) {
        budget.value = (price.value * goal.value).toFixed(2);
    }
}